<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    :width="width"
    :height="height"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.25 7.5C3.25 6.25736 4.25736 5.25 5.5 5.25H18.5C19.7426 5.25 20.75 6.25736 20.75 7.5V16.5C20.75 17.7426 19.7426 18.75 18.5 18.75H5.5C4.25736 18.75 3.25 17.7426 3.25 16.5V7.5ZM5.5 6.75C5.08579 6.75 4.75 7.08579 4.75 7.5V10.25H19.25V7.5C19.25 7.08579 18.9142 6.75 18.5 6.75H5.5ZM19.25 11.75H4.75V16.5C4.75 16.9142 5.08579 17.25 5.5 17.25H18.5C18.9142 17.25 19.25 16.9142 19.25 16.5V11.75Z"
      fill="currentColor"
    />
    <path d="M6.75 14.25H10.25V15.75H6.75V14.25Z" fill="currentColor" />
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class GiftCard extends Vue {
  @Prop({ default: 24 }) readonly width!: number | string;

  @Prop({ default: 24 }) readonly height!: number | string;
}
</script>
